import React from 'react'

export const ProjectApply = () => {
    return  (
        <React.Fragment>
             <div className="project_apply">
                <div>
                    <h3>Apply to project</h3>
                    <p>Join to the project!</p>
                </div>
                <div className="btn">
                    Apply
                </div>
            </div>
        </React.Fragment>
    ) 

}
